import script from "./Navbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=048dce7a&lang=css"

const __exports__ = script;

export default __exports__